window.addEventListener( "pageshow", function ( event ) {
  var historyTraversal = event.persisted || 
                         ( typeof window.performance != "undefined" && 
                              window.performance.navigation.type === 2 );
  if ( historyTraversal ) {
    window.location.href = window.location.href.replace(window.location.hash,"");
  }
});

  const lockString = "#lock";
  var cookieExpiry = new Date();
  cookieExpiry.setTime(cookieExpiry.getTime() + (365 * 24 * 60 * 60 * 1000)); 

  $(document).ready(function(){
      /****LANDING DOWNLOAD START*****/
      let url = new URL(window.location.href);
      let download = url.searchParams.get('download');
      
      if (download) {
          var target = download;
          var type = "externalPageDownload";
    
          $.cookie("unlock-target",target);
          $.cookie("unlock-type",type);
          var inst = $('[data-remodal-id=register-form-modal]').remodal();
          inst.open();
          removeHash();
          $('#unlockForm').show();
      }
      /****LANDING DOWNLOAD END*******/

  setupForUnlockAccess();

    $('#optin_checkbox').change(
      function(e) {
        $('#optin').val( $(this).is(':checked') ? "true" : "false" );
      }
    );

  $('form#unlockForm').submit(
    function(e)
    {
        $.cookie("unlock-verified","true", { expires: cookieExpiry });
    }
  );

if ($.cookie("unlock-target") && $.cookie("unlock-verified") !== undefined) {  //download and unset cookie for unlock-target
  let target = $.cookie("unlock-target");
  let type = $.cookie("unlock-type");
  $.removeCookie("unlock-target");
  $.removeCookie("unlock-type");

  if (type == "download") {
    $('body').append('<a href="#" id="workHref" target="_blank" rel="noopener" />');
    $('#workHref')[0].href = target;
    $('#workHref')[0].click();
  }
  
  if (type == "link") {
    window.location.href = target;
  }

  if (type == "externalPageDownload") {
    window.location.href = target;
  }

  if (type == "video") {
    //var symbol = $("#" + target)[0].src.indexOf("?") > -1 ? "&" : "?";
    var thisElement = $(document).find("iframe")[target];
    var symbol = thisElement.src.indexOf("?") > -1 ? "&" : "?";
    thisElement.src += symbol + "autoplay=1";
  }
}
});

function verifyForm() {
  if (!recaptchaSuccess) {
    $('div.g-recaptcha div').first().addClass('require');
    return false;
  }

  return true;
}

function removeHash() {
  var currentURL = window.location.href;

  if (window.location.hash) {
      window.history.pushState("", document.title, currentURL.split('#')[0]);
  }
}

function setupShogunObserver() {
  let observer = new MutationObserver(mutationRecords => {
    setupForUnlockAccess();
    observer.disconnect();
  });

  $( document ).ready(function() { 
    //observer.observe($(".shogun-root")[0], {
    observer.observe($("#page")[0], {                           ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      childList: true,
      subtree: true,
      characterDataOldValue: true,
    });  
  });
}

function isFileHref(href) {
  if (! href) return false;
  
  href = href.toLowerCase();
  
  if (( href.indexOf('.doc') > -1 || href.indexOf('.pdf') > -1 || href.indexOf('.zip') > -1 || href.indexOf('.xls') > -1 ))
    return true;
  else
    return false;
}

function setupForUnlockAccess() {    
  
  if ($.cookie("unlock-verified") === undefined) {
    
    $('a').each(function(){
      let href = $(this).attr('href');

      if (href == '')
        return;

      if ( href.indexOf(lockString) == -1 )
        return;  

      href = href.replace(lockString,"");

      $(this).attr('data-link',btoa(href));
      $(this).attr('href','');
      $(this).parent().addClass('unlock-link');
    });
  }
  else if ($.cookie("unlock-verified") == "true") {
    $('.unlock-link a').each(function(){
           $(this).addClass("unlocked");
    });
    $('a').each(function(){
      let href = $(this).attr('href');
      
      if ( href.indexOf(lockString) > -1 )
          $(this).attr('href',href.replace(lockString,""));
      
      if ($(this).attr('data-unlocktext'))
          $(this).text($(this).attr('data-unlocktext'));
    });
  }

  $('u').click(
    function(e)
    {
      return handleAClick(e);
    }
  );

  $('a').click(
    function(e)
    {
      return handleAClick(e);
    }
  );
}

$(document).on('click','.overlay',
  function (e) {
      return handleIframeClick($(e.target).parent().find('iframe').first());
    }
);

function handleAClick(e) {

   let eventTarget = e.target;

   if ( $(eventTarget).prop('nodeName') == 'U' ) //handles <u> elements inside the <a>
     eventTarget = $(eventTarget).closest('a')[0];

   if ( eventTarget.getAttribute('data-link') == null )  //allow standard non-content links through
     return true;

   if ($.cookie("unlock-verified") !== undefined)
        return true;
    var target = atob(eventTarget.getAttribute('data-link'));
    var type = "download";
  
    if (! isFileHref(target) )
      type = "link";
    $('#first_download').val(target);
    $.cookie("unlock-target",target);
    $.cookie("unlock-type",type);
    $.cookie("unlock-redirect",window.location.href);
    var inst = $('[data-remodal-id=register-form-modal]').remodal();
    inst.open();
    removeHash();
    $('#unlockForm').show();
     return false;
}

function handleIframeClick(iframe) {

   var iframeIndex = $(document).find("iframe").index($(iframe));

   if ($.cookie("unlock-verified") !== undefined)
        return true;
  
    //$.cookie("unlock-target",$(iframe).attr('id'));
    $.cookie("unlock-target",iframeIndex);
    $.cookie("unlock-type","video");
    $.cookie("unlock-redirect",window.location.href);
    var inst = $('[data-remodal-id=register-form-modal]').remodal();
    inst.open();
    removeHash();
    $('#unlockForm').show();
     return false;
}

if ($.cookie("unlock-verified") !== undefined)
  $('.overlay').remove();

setupShogunObserver();